/* unplugin-vue-components disabled */import { render } from "./TextLogicalReasoningQuestionEditor.vue?vue&type=template&id=54c4e48f&scoped=true"
import script from "./TextLogicalReasoningQuestionEditor.vue?vue&type=script&lang=js"
export * from "./TextLogicalReasoningQuestionEditor.vue?vue&type=script&lang=js"

import "./TextLogicalReasoningQuestionEditor.vue?vue&type=style&index=0&id=54c4e48f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54c4e48f"]])

export default __exports__